import { EventPanelFormType } from '@mark43/cad-api';

export const eventPanelFormInitialValues: EventPanelFormType = {
    additionalCallForServices: [],
    callForService: null,
    diagnostics: {},
    clearEventAdditionalDispositions: [],
    clearEventComments: '',
    clearEventPrimaryDisposition: null,
    drugs: [],
    mergedDrugs: [],
    emsAgency: null,
    emsDispatchArea: null,
    emsPrimaryRadioChannel: null,
    emsSubdivision1: null,
    emsSubdivision2: null,
    emsSubdivision3: null,
    emsSubdivision4: null,
    emsSubdivision5: null,
    eventId: null,
    eventLabels: [],
    eventOrigin: null,
    eventQueue: null,
    firearms: [],
    fireAgency: null,
    fireDispatchArea: null,
    firePrimaryRadioChannel: null,
    fireSubdivision1: null,
    fireSubdivision2: null,
    fireSubdivision3: null,
    fireSubdivision4: null,
    fireSubdivision5: null,
    location: null,
    locationNotes: '',
    locationSubPremise: '',
    mergedFirearms: [],
    narrative: '',
    phoneCall: null,
    policeAgency: null,
    policeDispatchArea: null,
    policePrimaryRadioChannel: null,
    policeSubdivision1: null,
    policeSubdivision2: null,
    policeSubdivision3: null,
    policeSubdivision4: null,
    policeSubdivision5: null,
    priority: null,
    alarmLevel: null,
    additionalRadioChannels: [],
    childAdditionalRadioChannels: [],
    reportingParties: [],
    mergedReportingParties: [],
    involvedPersons: [],
    mergedInvolvedPersons: [],
    riskLevel: null,
    vehicles: [],
    mergedVehicles: [],
    towVehicles: [],
    mergedTowVehicles: [],
    selfInitiateUnitId: null,
    deviceName: '',
    eventCommunication: null,
    scheduledEventEndDateTime: '',
    scheduledEventFrequency: null,
    scheduledEventStartDateTime: null,
    vehicleQueryAllOnSave: false,
    // The generated type is string[] and cannot express "absent", so this has to be an array. Safe
    // here because these are new-event initial values and a new event has no links to remove --
    // but see EventPanelForm.sensorAlertKeys: an empty array sent on an *existing* event means
    // "remove them all", so do not reuse this value as a base for an edit form.
    sensorAlertKeys: [],
    eventOrigin911: false,
    initiatedDateTimeUtc: '',
    otherItems: [],
    mergedOtherItems: [],
    oriAliasOption: null,
    proQaTemporaryIncidentId: null,
};
